import { forwardRef } from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";

// Pulsante «Azioni» (al posto dei tre puntini): grande abbastanza da toccare col dito.
export const ActionsButton = forwardRef(({ className = "", ...props }, ref) => (
  <Button ref={ref} variant="outline" size="sm" className={`h-11 px-3 gap-1 text-sm font-medium ${className}`} {...props}>
    Azioni <ChevronDown className="w-4 h-4" />
  </Button>
));
ActionsButton.displayName = "ActionsButton";

export default ActionsButton;
